<template>
  <div class=" my-1">
    <span class="badge badge-secondary ml-1 p-1" v-for="tag in (tags || [])" >{{tag.name}}</span>
  </div>
</template>

<script>

export default {
  props: {
    tags: Array,
  },
}
</script>
